<template>
  <div class="acc_event_cla">
    <zkThreeRow>
      <div slot="search" class="acc_search_cla">
        <el-form :model="searchParams" :inline="true">
          <el-form-item label="">
            <el-select
              v-model="searchParams.protocol"
              :placeholder="$t('sysOption.searchProtocol')"
              style="width:100px"
              clearable
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              style="width: 140px;"
              v-model="searchParams.type"
              :placeholder="$t('sysOption.eventType')"
              clearable
            >
              <el-option
                v-for="item in selectOption"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="searchParams.value"
              :placeholder="$t('common.inputKeyWord')"
            >
              <template slot="append">
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  style="cursor: pointer;"
                  @click="getDeviceParamsList"
                ></el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <ZkButtonGroup
          :showText="true"
          @addDeviceParams="addDeviceParams"
          size="mini"
          :event="['addDeviceParams']"
          :isLoadGroupName="true"
          :isGroup="true"
          groupName="device_params_btn_group"
        ></ZkButtonGroup>
      </div>
      <div slot="table">
        <zk-table :data="tableData" :columns="column" v-if="show"></zk-table>
        <div class="pagination-margin-top">
          <el-pagination
            background
            @size-change="pageSizeChange(arguments[0], getDeviceParamsList)"
            @current-change="curPageChange(arguments[0], getDeviceParamsList)"
            :current-page="pager.curPage"
            :page-size="pager.pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="pager.total"
          ></el-pagination>
        </div>
      </div>
    </zkThreeRow>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="40%"
      @close="handleClose"
    >
      <el-form
        :model="formData"
        label-width="160px"
        ref="formData"
        :rules="rules"
      >
        <el-form-item
          :label="$t('sysOption.originalParam')"
          prop="originalParam"
        >
          <el-input
            v-model="formData.originalParam"
            :placeholder="$t('sysOption.inputOriginalParams')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('sysOption.saveParam')" prop="saveParam">
          <el-input
            v-model="formData.saveParam"
            :placeholder="$t('sysOption.inputSaveParam')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('sysOption.protocol')" prop="protocol">
          <!-- <zk-dictionary-select
            style="width:100%"
            :multiple="true"
            :placeholder="'请选择通讯协议'"
            :clearable="clearable"
            type="protocol"
            :value="formData.protocol"
            v-model="formData.protocol"
          ></zk-dictionary-select> -->
          <el-select
            v-model="formData.protocol"
            multiple
            :placeholder="$t('sysOption.searchProtocol')"
            style="width:100%"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('sysOption.readWay')" prop="type">
          <zk-dictionary-select
            style="width:100%"
            :placeholder="$t('sysOption.inputReadWay')"
            :clearable="clearable"
            type="readWay"
            v-model="formData.type"
            :value="formData.type"
          ></zk-dictionary-select>
        </el-form-item>
        <el-form-item :label="$t('sysOption.isAllow')" prop="modify">
          <zk-dictionary-select
            style="width:100%"
            :placeholder="$t('sysOption.selectWay')"
            :clearable="clearable"
            type="allow"
            v-model="formData.modify"
            :value="formData.modify"
          ></zk-dictionary-select>
        </el-form-item>
        <el-form-item :label="$t('sysOption.connect')" prop="connect">
          <el-input
            v-model="formData.connect"
            :placeholder="$t('sysOption.inputConnection')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('sysOption.paramsValue')" prop="valueType">
          <zk-dictionary-select
            style="width:100%"
            :placeholder="$t('sysOption.selectWay')"
            :clearable="clearable"
            type="paramstype"
            v-model="formData.valueType"
            :value="formData.valueType"
          ></zk-dictionary-select>
        </el-form-item>
        <el-form-item :label="$t('sysOption.dictionary')" prop="dictionaryType">
          <el-input
            v-model="formData.dictionaryType"
            :placeholder="$t('sysOption.inputDictionary')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitDeviceParams">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDeviceParamsList,
  addDeviceParamsList,
  updateDeviceParamsList,
  deleteDeviceParamsList
} from '@/services/sysOptionsApi.js'
import { getByType } from '@/cdpBase/services/dictionary.js'
// import { dateFormat, dateByTimestamp } from '../../../utils/utils.js'
export default {
  data() {
    let _self = this
    return {
      tableData: [],
      paramsType: {},
      column: [
        {
          label: this.$t('sysOption.originalParam'),
          prop: 'originalParam'
        },
        {
          label: this.$t('sysOption.saveParam'),
          prop: 'saveParam'
        },
        {
          label: this.$t('sysOption.protocol'),
          props: 'protocol',
          render: (h, params) => {
            let isData = this.isEmptyData(params.row.protocol)
            return h('span', {}, isData ? 'N/A' : params.row.protocol)
          }
        },
        {
          label: this.$t('sysOption.readWay'),
          props: 'type',
          render: (h, params) => {
            return h(
              'span',
              params.row.type === 1
                ? this.$t('sysOption.readAndWrite')
                : this.$t('sysOption.onlyRead')
            )
          }
        },
        {
          label: this.$t('sysOption.isAllowModify'),
          props: 'type',
          render: (h, params) => {
            return h('ZkDictionaryValue', {
              key: params.row.id,
              props: {
                type: 'allow',
                value: params.row.modify
              }
            })
          }
        },
        {
          label: this.$t('sysOption.connect'),
          prop: 'connect',
          render: (h, params) => {
            return h(
              'div',
              this.isEmptyData(params.row.connect) ? 'N/A' : params.row.connect
            )
          }
        },
        {
          label: this.$t('sysOption.paramsValueType'),
          props: 'valueType',
          render: (h, params) => {
            return h('ZkDictionaryValue', {
              key: params.row.id,
              props: {
                type: 'paramstype',
                value: params.row.valueType
              }
            })
          }
        },
        {
          label: this.$t('sysOption.dictionaryType'),
          props: 'dictionaryType',
          render: (h, params) => {
            return h(
              'span',
              this.isEmptyData(params.row.dictionaryType)
                ? 'N/A'
                : params.row.dictionaryType
            )
          }
        },
        // {
        //   label: '创建者',
        //   props: 'createBy',
        //   render: (h, params) => {
        //     return h(
        //       'span',
        //       {},
        //       this.isEmptyData(params.row.createBy)
        //         ? 'N/A'
        //         : params.row.createBy
        //     )
        //   }
        // },
        // {
        //   label: '修改者',
        //   props: 'updateBy',
        //   render: (h, params) => {
        //     return h(
        //       'span',
        //       {},
        //       this.isEmptyData(params.row.updateBy)
        //         ? 'N/A'
        //         : params.row.updateBy
        //     )
        //   }
        // },
        {
          label: this.$t('common.operation'),
          render: (h, params) => {
            return h('ZkButtonGroup', {
              props: {
                showText: true,
                groupName: 'device_params_btn_group',
                showTip: true,
                isLoadGroupName: true,
                params: params.row,
                size: 'mini',
                isGroup: true,
                event: ['editDeviceParams', 'deleteDeviceParams'],
                onlyShowText: true
              },
              on: {
                editDeviceParams() {
                  _self.editDeviceParams(params.row)
                },
                deleteDeviceParams() {
                  _self.deleteDeviceParams(params.row)
                }
              }
            })
          }
        }
      ],
      show: true,
      searchParams: {
        type: '',
        value: '',
        protocol: ''
      },
      selectOption: [
        {
          label: this.$t('sysOption.originalParam'),
          value: 0,
          attr: 'originalParam'
        },
        {
          label: this.$t('sysOption.saveParam'),
          value: 1,
          attr: 'saveParam'
        }
        // {
        //   label: '通讯协议',
        //   value: 2,
        //   attr: 'protocol'
        // }
      ],
      dialogVisible: false,
      title: '',
      isUpdate: false,
      formData: {
        originalParam: '',
        saveParam: '',
        protocol: '',
        type: '',
        modify: '',
        connect: '',
        valueType: '',
        dictionaryType: ''
      },
      rules: {
        originalParam: this.validatorInputEmptyRule(true),
        saveParam: this.validatorInputEmptyRule(true),
        protocol: this.validatorInputEmptyRule(true),
        type: this.validatorInputEmptyRule(true),
        modify: this.validatorInputEmptyRule(true),
        valueType: this.validatorInputEmptyRule(true)
      },
      options: []
    }
  },
  methods: {
    getProtorlParams() {
      getByType('protocol').then(data => {
        let result = data.results.results
        this.options = []
        result.forEach(item => {
          this.options.push({
            value: item.value,
            label: item.label
          })
        })
      })
    },
    submitDeviceParams() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.formData))
          params.protocol = params.protocol.toString() // 数组=> 字符串
          if (this.isUpdate) {
            updateDeviceParamsList(params)
              .then(data => {
                if (data.code === '00000000') {
                  this.successMessage(this.$t('successOperation.update'))
                  this.getDeviceParamsList()
                  this.show = false
                  setTimeout(() => {
                    this.show = true
                    this.handleClose()
                  }, 50)

                  // this.handleClose()
                } else {
                  this.errorMessage(data.message)
                }
              })
              .catch(e => console.log(e))
          } else {
            delete params.id
            addDeviceParamsList(params)
              .then(data => {
                if (data.code === '00000000') {
                  this.successMessage(this.$t('successOperation.add'))
                  this.getDeviceParamsList()
                  this.handleClose()
                } else {
                  this.errorMessage(data.message)
                }
              })
              .catch(e => {
                console.log(e)
              })
          }
        }
      })
    },
    addDeviceParams() {
      this.dialogVisible = true
      this.title = this.$t('sysOption.addDeviceParams')
      this.isUpdate = false
    },
    editDeviceParams(row) {
      this.dialogVisible = true
      this.title = this.$t('sysOption.updateDeviceParams')
      this.isUpdate = true
      this.formData.id = row.id
      Object.keys(this.formData).map(key => {
        if (key === 'protocol') {
          this.formData[key] = row[key].split(',')
        } else {
          this.formData[key] = row[key]
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.title = ''
      setTimeout(() => {
        Object.keys(this.formData).map(key => (this.formData[key] = ''))
      }, 300)
    },

    deleteDeviceParams(row) {
      this.$confirm(this.$t('sysOption.deleteParams'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      })
        .then(() => {
          deleteDeviceParamsList({ id: row.id })
            .then(data => {
              if (data.code === '00000000') {
                this.successMessage(this.$t('successOperation.delete'))
                this.getDeviceParamsList()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch(e => console.log(e))
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    getDeviceParamsList() {
      let finallyParams = {}
      if (this.searchParams.protocol) {
        finallyParams.protocol = this.searchParams.protocol
      }

      if (this.searchParams.type !== '') {
        this.selectOption.forEach(item => {
          if (item.value === this.searchParams.type) {
            finallyParams[item.attr] = this.searchParams.value
          }
        })
      } else {
        finallyParams.condition = this.searchParams.value
      }
      let params = {
        params: finallyParams,
        pager: this.pager
      }
      getDeviceParamsList(params).then(data => {
        if (data.code === '00000000') {
          const { results, totalRecords } = data.payload
          this.tableData = results
          this.pager.total = totalRecords
        } else {
          this.errorMessage(data.message)
        }
      })
    }
  },
  mounted() {
    this.getDeviceParamsList()
    this.getProtorlParams()
  }
}
</script>

<style scoped lang="less">
.acc_event_cla {
  margin-top: 15px;
  .acc_search_cla {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/sysOptions/accDevice/deviceParams.vue